import { FilterModel } from '@/models/Filter';
import axios, { AxiosResponse } from 'axios';

export default class ProductListFilterService {
    private profileId: string = (window as any).CbxApiContextKey;
    private endpoint: string;

    constructor(args: any = {}) {
        if (args.profileId) this.profileId = args.profileId;
        this.endpoint = `/contextapi/${this.profileId}/v1/product/productsearch`;
    }

    public async getFilterResult(payload: FilterModel): Promise<FilterModel> {
        // remove unnecessary properties from the payload before sending
        const p: FilterModel = {
            categories: payload.categories,
            rootcategory: payload.rootcategory,
            count: payload.count,
            offset: payload.offset,
            searchphrase: payload.searchphrase,
            preselections: payload.preselections,
            selections: payload.selections,
            sortoptions: payload.sortoptions,
            restrictdoctypes: payload.restrictdoctypes,
            includedescendantcategories: payload.includedescendantcategories,
            fields: payload.fields.map((f) => {
                return {
                    path: f.path,
                    type: f.type,
                };
            }),
            usefuzzymatch: false,
        };

        if (payload.usecontentrelationsasselection) {
            p.usecontentrelationsasselection = true;
            p.contentrelationnodeid = payload.contentrelationnodeid;
        }

        try {
            const res: AxiosResponse<FilterModel> = await axios.post(`${this.endpoint}`, p);
            return res.data;
        } catch (e) {
            return {};
        }
    }
}
